$( document ).on('turbolinks:load', function() {
  if($(location).attr('pathname').includes("/custom_funil")){
    setTimeout(function() {
      const urlParams = new URLSearchParams(window.location.search);
      const email = urlParams.get('email')
      window.location.replace("/custom_funil_page?email=" + email);
    }, 5000)
  }
})
